/**
 * row-no — 표 맨 왼쪽의 순번 칸. 제품 · 재고 표 전부가 쓴다(현민 2026-10-20 — 이카운트 품목등록 리스트처럼 맨 왼쪽에 순번).
 * 번호는 쪽을 넘겨도 이어진다 — offset + 줄 차례 + 1. 줄의 id 가 아니라 "이 목록에서 몇째 줄" 이다.
 */

export const ROW_NO_HEAD = '<th class="pl-no">#</th>';

export function rowNoCell(offset: number, index: number): string {
  return `<td class="pl-no mono">${offset + index + 1}</td>`;
}
